/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { ListGroupItem } from 'external/react-bootstrap';

class NamedListListItem extends React.Component {

    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        this.props.onClick(this.props.item, e);
    }

    render() {
        const { item, ...otherProps } = this.props;

        return (
            <ListGroupItem {...otherProps} onClick={this.onClick}>
                {item.title}
            </ListGroupItem>
        );
    }
}

NamedListListItem.propTypes = {
    ...ListGroupItem.propTypes,
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func
};

export default NamedListListItem;



// WEBPACK FOOTER //
// ./js/components/NamedListListItem.jsx